import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../../../../core/modules/common/components/Button';
import { getCurrentReport, getUserType } from '../../../user/redux/selectors/UserReportSelectors';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData } from '../redux/actions/ReportsActions';
import { getReportCustomFilter } from '../redux/selectors/ReportsSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import ReportDefinitions from '../../../common/config/ReportDefinitions';

class ReportCustomFiltersMrdPodOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mrdLikeStatus: this.props.customFilter.mrdLikeStatus,
    };
  }

  onShowMailboxesClick = () => {
    this.loadReport({
      ...this.state,
      mrdLikeStatus: !this.state.mrdLikeStatus,
    });
  };

  loadReport = (state) => {
    const { reportCode } = this.props.currentReport;
    const report = ReportDefinitions[reportCode];
    const selectionCriteria =
      new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    this.props.reportLoadData(report, reportCode, {
      ...selectionCriteria,
      ...state,
    });
    this.setState(state);
  };

  render() {
    return (
      <div className="custom-filter-list">
        <Button
          onClick={this.onShowMailboxesClick}
          text={this.state.mrdLikeStatus ?
            'app.report.exclude.mrdLike.button' : 'app.report.include.mrdLike.button'}
        />
      </div>
    );
  }
}

ReportCustomFiltersMrdPodOverview.propTypes = {
  currentReport: PropTypes.objectOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  customFilter: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportLoadData,
  }, dispatch);

const mapStateToProps = state => ({
  currentReport: getCurrentReport(state),
  currentUserType: getUserType(state),
  selectionCriteria: getSelectionCriteria(state),
  customFilter: getReportCustomFilter(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCustomFiltersMrdPodOverview);
